import {Children} from 'react'

/**
 * Wrap text nodes in <span> so that styling can apply, for example, an asterisk
 * next to indicate required next to a label. This comes from welcome-ui.
 */
export const wrapChildren = children =>
  Children.map(children, child =>
    ['number', 'string'].includes(typeof child) ? (
      <span key={child}>{child}</span>
    ) : (
      child
    ),
  )
